import _ from 'lodash';
import React, { Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import SubList from './sub-list';

class SubscriptionList extends React.Component {
    render () {
        const { member, cancelled } = this.props;

		const activeSubscriptions = member.subscribedTo.filter(s => s.active !== false);
		const cancelledSubscriptions = member.subscribedTo.filter(s => s.active === false);

		if (!cancelled && _.isEmpty(activeSubscriptions)) {
			return (<em>No subscriptions</em>);
		}
		if (cancelled && _.isEmpty(cancelledSubscriptions)) {
			return (<em>No cancelled subscriptions</em>);
		}

        return (
            <div>
                <SubList subscriptions={member.subscribedTo} showCancelled={cancelled} />
            </div>
        )
    }
}
export default SubscriptionList;